export const GET_RESTAURANT_SETTINGS = 'GET_RESTAURANT_SETTINGS';

export function getRestaurantSettings() {
  return {
    type: GET_RESTAURANT_SETTINGS,
    request: {
      op: 'get',
      path: '/@restaurant-settings',
    },
  };
}

// Loads the settings during server rendering, so the HTML that crawlers and
// share previews read already holds the configured values. The browser gets
// them with the serialized store and does not fetch them again.
export const restaurantSettingsAsyncPropExtender = {
  path: '/',
  extend: (dispatchActions: any[]) => {
    if (!dispatchActions.some((item) => item.key === GET_RESTAURANT_SETTINGS)) {
      dispatchActions.push({
        key: GET_RESTAURANT_SETTINGS,
        promise: ({ store }: any) => {
          if (store.getState().restaurantSettings?.loaded) return null;
          // A failed request must not break the page. The defaults apply.
          return store.dispatch(getRestaurantSettings()).catch(() => null);
        },
      });
    }
    return dispatchActions;
  },
};
